/**
 * Main javascript entry point
 * Should handle bootstrapping/starting application
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

/*global window, document, jQuery, $, require, alert, location, parent, global */
import 'promise-polyfill/src/polyfill';
import Application from './core/app';
import Form from './core/form';
import axios from 'axios';

/**
 * First we will load all of this project's JavaScript dependencies which
 * include jQuery, Bootstrap, bootstrap-datepicker and bootstrap-select,
 * slick-slider, magnificPopup, mmenu, parsley, sweetalert and
 * cookieconsent. This gives a great starting point for building
 * robust, powerful web applications.
 */

require('./bootstrap');

/**
 * Setup some globals for objects we'll be using across application.
 */
window.Form = Form;
window.axios = axios;

window.axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest'
};

var token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

/**
 * Next, we will create a fresh Application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

var App = new Application();

/** Expose the App to browser window object */
window.App = App;

/**
 * Initialize the application on document ready. All code that needs
 * to be executed when page is done, should be handled from within the
 * Application init method.
 */

// $(() => {
//     App.init(); // App initialized in footer;
// })


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/js/app.js
// module id = null
// module chunks = 